import React from "react";
import pages from "../../constants/pages.js";
import Form from "../../pages/sign in components/Form.js";
import SignUp from "../../pages/sign up components/SignUp.js";
import appointment from "../../pages/appointment components/Home.js";

const authLayoutRoutes = {
  appointmentPageRoute: {
    ID: "appointment",
    path: pages.appointment.route,
    element: appointment,
  },

  signInRoute: {
    ID: "sign-in",
    path: pages.SignIn.route,
    element: Form,
  },

  signOutRoute: {
    ID: "sign-up",
    path: pages.SignUp.route,
    element: SignUp,
  },
};

export default authLayoutRoutes;
